(function giftScript(Drupal, $, once) {
  Drupal.behaviors.gift = {
    attach(context) {
      $('.gift-item__description-label', context).each(
        function toggleGiftDetails(index) {
          const $this = $(once('giftScript', $(this)));
          const id = index + 1;
          $this.next('.gift-item__description-text').wrapAll(`
            <div id="helps-${id}" aria-describedby="toggle-${id}" aria-hidden="true" class="gift-item__description-wrapper">`);
          const $panel = $this.next();

          $this.wrapInner(`
            <button id="toggle-${id}" aria-controls="helps-${id}" aria-expanded="false" class="js-toggle-description">`);
          const $button = $this.children('button');

          $button.append(
            '<svg focusable="false" aria-hidden="true" width="34" height="18" viewBox="0 0 34 18"><path fill="#9B9B9B" fill-rule="evenodd" d="M31.5.3c.5-.4 1.2-.4 1.7 0 .5.5.5 1.2 0 1.7L17.6 17.7c-.5.4-1.2.4-1.7 0L.3 2C0 1.5 0 .8.3.3.8 0 1.5 0 2 .3l14.8 14.9L31.5.3z"/></svg>'
          );

          $button.on('click', function toggleState() {
            const state = $(this).attr('aria-expanded') === 'false';
            $(this).attr('aria-expanded', state);
            $panel.attr('aria-hidden', !state);
          });
        }
      );

      $('.gift-item__form .form-item-quantity-0-value', context).each(
        function quantityIncrement() {
          const $this = $(once('giftScript', $(this))); //$(this);
          const minusBtn =
            '<button value="-" class="quantity-minus quantity-button" aria-hidden="true">-</button>';
          const plusBtn =
            '<button value="+" class="quantity-plus quantity-button" aria-hidden="true">+</button>';
          $this.prepend(minusBtn);
          $this.append(plusBtn);

          $this
            .children('.quantity-button')
            .on('click', function incrementBtn(e) {
              const $button = $(this);
              const oldValue = $button
                .parent()
                .find('input')
                .val();
              let newVal = parseFloat(oldValue) + 1;

              e.preventDefault();

              if ($button.val() === '-') {
                newVal = parseFloat(oldValue) + 1;
                // Don't allow decrementing below one
                if (oldValue > 1) {
                  newVal = parseFloat(oldValue) - 1;
                } else {
                  newVal = 1;
                }
              }

              $button
                .parent()
                .find('input')
                .val(newVal);
            });
        }
      );
    }
  };
}(Drupal, jQuery, once));
